// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XpxyPf {
  padding: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
}

.iR4UGJ {
  display: grid;
  grid-template-columns: minmax(0, 22.125fr) repeat(4, minmax(0, 10.3125fr));
  gap: var(--spacing-3);
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 70rem) {
  .iR4UGJ {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .rz31cn {
    grid-column: 1 / -1;
    width: 100%;
    max-width: none;
    justify-self: stretch;
  }

  .NPN2J4 {
    width: 100%;
    max-width: none;
    justify-self: stretch;
  }
}

@media (max-width: 36rem) {
  .iR4UGJ {
    grid-template-columns: 1fr;
  }
}

.rz31cn {
  min-height: 10.3125rem;
  box-sizing: border-box;
  background: var(--surface-primary-medium);
  border-radius: var(--card-border-radius);
  padding: var(--spacing-3) var(--spacing-1-5);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.625rem;
}

.LOYv2k {
  width: 2.625rem;
  height: 2.625rem;
  flex-shrink: 0;
  display: block;
  object-fit: contain;
}

.wIHDlr {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-white);
  text-align: center;
  font-family: var(--font-family-base);
}

.NPN2J4 {
  min-height: 10.3125rem;
  box-sizing: border-box;
  border: none;
  border-radius: var(--card-border-radius);
  padding: var(--spacing-3) var(--spacing-1-5);
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.625rem;
}

.sAMCb1 {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: center;
  font-family: var(--font-family-base);
}

.R1oaCS {
  text-wrap: balance;
  max-width: 100%;
}

.R1oaCS .WNbY7F {
  font-size: var(--font-size-md);
  line-height: 0;
  vertical-align: middle;
  margin-left: 0.125rem;
}

.hga6S4 {
  border: none;
  background: none;
  padding: 0;
  cursor: help;
  display: inline-flex;
  vertical-align: middle;
  line-height: 0;
}

.hga6S4 > span {
  transform: scale(0.75);
  transform-origin: center;
}

.oiZh_l {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-0-5);
  width: 100%;
}

.kdRDJX {
  border: none;
  background: none;
  padding: 0;
  margin-top: 0;
  align-self: center;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  color: var(--link-default);
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
  font-family: var(--font-family-base);
}

.kdRDJX:hover {
  color: var(--link-hover);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesFeaturesRow/InsideSalesFeaturesRow.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0EAA0E;EAC1E,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yCAAyC;EACzC,wCAAwC;EACxC,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;EACxC,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".section {\n  padding: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: minmax(0, 22.125fr) repeat(4, minmax(0, 10.3125fr));\n  gap: var(--spacing-3);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 70rem) {\n  .row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n  }\n\n  .cardHighlight {\n    grid-column: 1 / -1;\n    width: 100%;\n    max-width: none;\n    justify-self: stretch;\n  }\n\n  .card {\n    width: 100%;\n    max-width: none;\n    justify-self: stretch;\n  }\n}\n\n@media (max-width: 36rem) {\n  .row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.cardHighlight {\n  min-height: 10.3125rem;\n  box-sizing: border-box;\n  background: var(--surface-primary-medium);\n  border-radius: var(--card-border-radius);\n  padding: var(--spacing-3) var(--spacing-1-5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.625rem;\n}\n\n.featureIconLayer {\n  width: 2.625rem;\n  height: 2.625rem;\n  flex-shrink: 0;\n  display: block;\n  object-fit: contain;\n}\n\n.highlightText {\n  margin: 0;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-white);\n  text-align: center;\n  font-family: var(--font-family-base);\n}\n\n.card {\n  min-height: 10.3125rem;\n  box-sizing: border-box;\n  border: none;\n  border-radius: var(--card-border-radius);\n  padding: var(--spacing-3) var(--spacing-1-5);\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.625rem;\n}\n\n.cardText {\n  margin: 0;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: center;\n  font-family: var(--font-family-base);\n}\n\n.cardTextWithTooltip {\n  text-wrap: balance;\n  max-width: 100%;\n}\n\n.cardTextWithTooltip .cardTooltipTrigger {\n  font-size: var(--font-size-md);\n  line-height: 0;\n  vertical-align: middle;\n  margin-left: 0.125rem;\n}\n\n.infoBtn {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: help;\n  display: inline-flex;\n  vertical-align: middle;\n  line-height: 0;\n}\n\n.infoBtn > span {\n  transform: scale(0.75);\n  transform-origin: center;\n}\n\n.cardStack {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  width: 100%;\n}\n\n.networkLink {\n  border: none;\n  background: none;\n  padding: 0;\n  margin-top: 0;\n  align-self: center;\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  color: var(--link-default);\n  cursor: pointer;\n  text-align: center;\n  text-decoration: underline;\n  font-family: var(--font-family-base);\n}\n\n.networkLink:hover {\n  color: var(--link-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `XpxyPf`,
	"row": `iR4UGJ`,
	"cardHighlight": `rz31cn`,
	"card": `NPN2J4`,
	"featureIconLayer": `LOYv2k`,
	"highlightText": `wIHDlr`,
	"cardText": `sAMCb1`,
	"cardTextWithTooltip": `R1oaCS`,
	"cardTooltipTrigger": `WNbY7F`,
	"infoBtn": `hga6S4`,
	"cardStack": `oiZh_l`,
	"networkLink": `kdRDJX`
};
module.exports = ___CSS_LOADER_EXPORT___;
